import { render } from "./ProjectPage1.vue?vue&type=template&id=d38db8ce&scoped=true"
import script from "./ProjectPage1.vue?vue&type=script&lang=js"
export * from "./ProjectPage1.vue?vue&type=script&lang=js"

import "./ProjectPage1.vue?vue&type=style&index=0&id=d38db8ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d38db8ce"]])

export default __exports__